import React from "react";
import { Link } from "react-router-dom";
import { FaShieldAlt } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import myntraLogo from "../image/dharajlogo.jpeg";

const CheckoutHeader = () => {
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase();

  const getActiveStep = () => {
    if (currentPath.includes("cart")) return "cart";
    if (currentPath.includes("checkout")) return "address";
    if (currentPath.includes("paymentsummary")) return "payment";
    return "";
  };

  const activeStep = getActiveStep();

  return (
    <>
      <style>
        {`
          .checkout-header {
            position: fixed;
            top: 0;
            left: 0;
            z-index: 2000;
            width: 100%;
            background-color: #fff;
            padding: 14px 60px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-bottom: 1px solid #eee;
            box-shadow: 0 4px 12px rgba(0,0,0,0.07);
            backdrop-filter: blur(8px);
          }

          .top-row {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;
          }

          .logo {
            width: 60px;
            height: 60px;
            object-fit: contain;
            cursor: pointer;
            transition: transform 0.25s ease;
          }

          .logo:hover {
            transform: scale(1.07);
          }

          .steps-container {
            display: flex;
            align-items: center;
            gap: 28px;
            font-size: 15px;
            font-weight: 600;
            letter-spacing: 1.5px;
            color: #7d7f89;
            text-transform: uppercase;
            justify-content: center;
            white-space: nowrap;
            margin-top: 8px;
          }

          .step {
            padding-bottom: 3px;
            cursor: pointer;
            opacity: 0.7;
            transition: all 0.3s ease;
          }

          .active-step {
            color: #03A685;
            border-bottom: 3px solid #03A685;
            font-weight: 700;
            opacity: 1;
          }

          .dash {
            color: #c7c7c7;
            font-size: 18px;
            opacity: 0.6;
            letter-spacing: 2px;
          }

          .secure-container {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .secure-text {
            color: #6c6c6c;
            font-size: 14px;
            font-weight: 600;
          }

          /* DESKTOP LAYOUT (>=768px) */
          @media screen and (min-width: 768px) {
            .checkout-header {
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
            }

            .mobile-steps {
              display: none;
            }

            .secure-container {
              display: flex;
            }
          }

          /* MOBILE LAYOUT (<768px) */
          @media screen and (max-width: 767px) {
            .checkout-header {
              padding: 14px 20px;
              flex-direction: column;
              align-items: center;
            }

            .top-row {
              flex-direction: column; /* logo on top */
              align-items: center;
              gap: 12px;
            }

            .mobile-steps {
              display: flex;
              width: 100%;
              justify-content: space-between;
              padding: 0 10px;
              margin-top: 8px;
            }

            /* HIDE SECURE TEXT ON MOBILE */
            
            .secure-container {
              display: none;
            }
              .steps-container{
              display: none;

              }

            .mobile-step {
              flex: 1;
              text-align: center;
              font-size: 13px;
              font-weight: 600;
              color: #7d7f89;
              text-transform: uppercase;
              padding: 6px 4px;
              border-radius: 4px;
            }

            .mobile-step.active {
              color: #03A685;
              font-weight: 700;
              border-bottom: 3px solid #03A685;
            }
          }
        `}
      </style>

      <div className="checkout-header">
        {/* TOP ROW: Logo + Secure */}
        <div className="top-row">
          <Link to="/">
            <img src={myntraLogo} alt="Logo" className="logo" />
          </Link>

          
        {/* DESKTOP STEPS */}
        <div className="steps-container">
          <span className={activeStep === "cart" ? "step active-step" : "step"}>
            Cart
          </span>
          <span className="dash">────</span>
          <span className={activeStep === "address" ? "step active-step" : "step"}>
            Address
          </span>
          <span className="dash">────</span>
          <span className={activeStep === "payment" ? "step active-step" : "step"}>
            Payment
          </span>
        </div>

        {/* MOBILE-ONLY STEPS */}
        <div className="mobile-steps">
          <span className={`mobile-step ${activeStep === "cart" ? "active" : ""}`}>Cart</span>
          <span className={`mobile-step ${activeStep === "address" ? "active" : ""}`}>Address</span>
          <span className={`mobile-step ${activeStep === "payment" ? "active" : ""}`}>Payment</span>
        </div>
        <div className="secure-container">
            <FaShieldAlt size={20} color="#03A685" />
            <span className="secure-text">100% SECURE</span>
          </div>
        </div>

      </div>
    </>
  );
};

export default CheckoutHeader;
